export const ENG_GOOGLE_PLAYSTORE = "https://play.google.com/store/apps/details?id=com.prothomalo.english";
export const ENG_APPLE_PLAYSTORE = "https://apps.apple.com/us/app/english-news-prothom-alo/id1289463331";
export const BN_GOOGLE_PLAYSTORE = "https://play.google.com/store/apps/details?id=com.mcc.prothomalo&hl=en_IN";
export const BN_APPLE_PLAYSTORE = "https://apps.apple.com/us/app/bangla-newspaper-prothom-alo/id548596669";
export const NA_GOOGLE_PLAYSTORE = "https://play.google.com/store/apps/details?id=com.prothomalo.northamerica&hl=en";
export const NA_APPLE_PLAYSTORE = "https://apps.apple.com/us/app/prothom-alo-north-america/id1289436839";

export const listValue = [
  { key: "bangla", value: "বাংলা" },
  { key: "english", value: "English" },
  { key: "north-america", value: "উত্তর আমেরিকা" },
];

export const storyTemplatesList = [
  { key: "all", value: "All" },
  { key: "text", value: "Text" },
  { key: "photo", value: "Photo" },
  { key: "video", value: "Video" },
  { key: "live-blog", value: "Live-Blog" },
  { key: "polls", value: "Polls" },
];

export const sortingList = [
  { key: "default", value: "Relevant" },
  { key: "latest-published", value: "Latest" },
  { key: "published-at:asc", value: "Oldest" },
];
